<template>
  <div>
    <v-row v-for="n in 10" :key="n">
      <v-col cols="12" class="pt-0">
        <v-skeleton-loader
          type="list-item-three-line"
          class="skeleton-list-item-three-line"
        >
        </v-skeleton-loader>
        <v-divider v-if="n != 10" :key="'d' + n"></v-divider>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'k-ertesites-list-skeleton',
  data() {
    return {};
  },
  mounted() {},
  created() {},
  methods: {},
  computed: {
    ...mapGetters({}),
  },
  watch: {},
  components: {},
};
</script>
